// eslint-disable-next-line no-use-before-define
import Avatar from './AvatarDropdown';
import LogoutButton from './LogoutButton';
import NotifLinks from './NotifLinks';
import ButtonComponent from 'components/Button';
import './index.less';
import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';
import DF from 'DisplayFramework';
import ThirdPartySearchButton from './ThirdPartySearchButton';
import FRflag from 'assets/FRflag.png';
import FormInput from 'components/FormInput';
import ParListSelect from 'components/ParListSelect';
import { useState } from 'react';
import { Popover, Button, Divider } from 'antd';

const GlobalHeaderRight = (props: any) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const hide = () => {
    setOpen(false);
  };

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };
  return (
    <DF.Provider pagcode="welcome">
      {!props.isExcludedFromLayout ? (
        <>
          <div>
            <ButtonComponent
              variant="outlined"
              color="primary"
              comcode="createtp"
              onClick={() => navigate('/thirdparty-sfs/create')}
              className='btn-header'
            />
          </div>
          <div>
            <ThirdPartySearchButton tptype='SPM' />
          </div>

          <div className={classNames('headerItem', 'hideOnMobile', 'd-none')}>
            <NotifLinks />
          </div>

          <div className={'headerItem'}>
            <Avatar />
          </div>

          <Popover
            content={
              <div className="ml2">
                <ul style={{ listStyle: "none" }}>
                  <li>Francais </li>
                  <Divider />
                  <li>English</li>
                </ul>
              </div>
            }

            trigger="click"
            open={open}
            onOpenChange={handleOpenChange}
          >

            <div className='Header-flag' id="lancode">
              {localStorage?.getItem('lancode') === 'FR' ? (
                <img
                  src={FRflag}
                  alt="French Flag"
                  style={{ width: '22px', cursor: "pointer" }}
                />
              ) : (
                <img src={FRflag} alt="French Flag" style={{ width: '22px', cursor: "pointer" }} />
              )}
            </div>
          </Popover>

          <div className={classNames('headerItem', 'ut-logout-button', 'd-flex')}>
            <LogoutButton />
          </div>
        </>
      ) : (
        <div className={'headerItem'}>
          <Avatar isExcludedFromLayout={props.isExcludedFromLayout} />
        </div>
      )}
    </DF.Provider>
  );
};

export default GlobalHeaderRight;
